import Dialog from "@mui/material/Dialog";
import * as React from "react";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import {CloseRounded} from "@mui/icons-material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import {isValidElement} from "react";
import {styled} from "@mui/material/styles";
import {AuthButtonVO} from "@/service/menu.s";
import {dialogClasses} from "@mui/material";
import {Breakpoint} from "@mui/system/createBreakpoints/createBreakpoints";
import {useDialogModal, useGlobalActions} from "@/store/global.c";

const ScrollDialogWrapper = styled(Box)<{ height?: number, maxWidth: Breakpoint }>(({height, maxWidth}) => ({

    overflowY: "scroll",
    overflowX: "hidden",
    background: "white",
    paddingBottom: "68px",
    "::-webkit-scrollbar": {
        width: 10,
        height: 10,
    },
    height: `calc(${maxWidth == 'xs' ? '60vh' : '80vh'} - 108px)`,
    "::-webkit-scrollbar-thumb": {
        [`& .${dialogClasses.paper}`]: {
            backgroundColor: "background.paper",
        },
        cursor: "pointer",
        borderRadius: "3px",
    },
    "&:hover::-webkit-scrollbar-thumb": {
        backgroundColor: "rgba(231,231,226)",
    },
}));


type DialogHeaderProps = {
    header: string | React.ReactNode;
    btns?: AuthButtonVO[]
    onClose: () => void;
};

type DialogFooterProps = {
    onSubmit?: () => void;
    onReset?: () => void;
    loading?: boolean
};

export const DialogHeader = ({btns, header, onClose}: DialogHeaderProps) => {
    return (
        <Stack
            paddingX={2}
            height={54}
            bgcolor={'#fff'}
            justifyContent={"space-between"}
            direction={"row"}
            borderBottom={"1px solid rgb(239, 237, 244)"}
            width={"100%"}
            alignItems={"center"}
        >
            {isValidElement(header) ? (
                <>{header}</>
            ) : (
                <Typography fontWeight={500} variant="h6">
                    {header}
                </Typography>
            )}
            <Stack spacing={1} direction={'row'} alignItems={'center'} alignContent={'center'}>
                {btns?.map((btn, index) => <Button variant="outlined" disabled={btn.disabled} key={index} sx={{maxWidth: '88px', fontSize: 10,}}
                                                   size={'small'}>{btn.menuName}</Button>)}
                <IconButton
                    onClick={onClose}
                    sx={{borderRadius: "8px", border: "1px solid rgb(239, 237, 244)"}}
                >
                    <CloseRounded color={"action"}/>
                </IconButton>
            </Stack>

        </Stack>
    );
};

export const DialogFooter = ({onSubmit, onReset, loading}: DialogFooterProps) => {
    return (
        <Stack
            paddingX={2}
            height={54}
            position={"absolute"}
            bottom={0}
            left={0}
            borderTop={"1px solid rgb(239, 237, 244)"}
            right={0}
            justifyContent={"space-between"}
            direction={"row"}
            width={"100%"}
            bgcolor={'#fff'}
            alignItems={"center"}
        >
            <Button disabled={loading} loading={loading} variant={"outlined"} onClick={onReset}>
                重置
            </Button>
            <Button
                disableElevation={true}
                onClick={onSubmit}
                color={"info"}
                type={'submit'}
                disabled={loading} loading={loading}
                variant={"contained"}
            >
                保存
            </Button>
        </Stack>
    );
};

export default function DialogModal() {
    const {open, header, body, btns, maxWidth = 'sm'} = useDialogModal();
    const {setDialogModal} = useGlobalActions();
    const onClose = () => {
        setDialogModal({open: false});
    };

    // useEffect(() => {
    //     const observer = new IntersectionObserver(([entry]) =>
    //     );
    //     headerRef?.current && observer.observe(headerRef?.current);
    // }, []);


    return (
        <Dialog
            maxWidth={maxWidth}
            fullWidth={true}
            slotProps={{
                paper: {
                    sx: {
                        borderLeft: "1px solid rgb(239, 237, 244)",
                        borderTopLeftRadius: 8,
                        borderBottomLeftRadius: 8,
                        boxShadow: "rgba(27, 27, 31, 0.07) 0px 1px 2px 0px",
                    },
                },
                backdrop: {sx: {background: "rgba(27, 27, 31, 0.2)"}},
            }}
            open={open}
            onClose={onClose}
        >
            <Box
                position={"relative"}
                overflow={"hidden"}
            >
                <DialogHeader btns={btns} header={header} onClose={onClose}/>
                <ScrollDialogWrapper maxWidth={maxWidth}>
                    <Box sx={{padding: "16px 10px 16px 20px"}}>
                        {body}
                    </Box>
                </ScrollDialogWrapper>
            </Box>
        </Dialog>
    );
}
